<div class="container">
        
    <div class='logo' (click)="nav.nav('')">
        <img src='./../../../assets/logo2.png' alt='logo' />
        <div id="mace">MACE</div>
        <div id="ass">ASSURANCE</div>
    </div>

    <div class="tel">
        <a id='tel' href="tel:+33386721995">Contactez-nous! <br> 03 86 72 19 95</a>
        <img (click)="goFb()" src="./../../../assets/fb.png" alt="fb">
        <img (click)="goLn()" src="./../../../assets/ln.png" alt="ln">
        <img (click)="goInsta()" src="./../../../assets/insta.png" alt="insta">
    </div> 

    <div class="burger" (click)="menuOpen = !menuOpen;">
        <picture>
            <source 
                srcset="./../../../assets/webp/burger.webp" 
                type="image/webp" alt="menu">
            <!--fallback-->
            <img src="./../../../assets/burger.png" alt="menu">
        </picture>
    </div>

    <div class="rubriques" (mouseleave)="ongletsVis = false;" [class.open] = "menuOpen">
        <div class="rubr" (click)="this.menuOpen = false; nav.nav('');">
            Devis
        </div> 

        <div *ngIf="!menuOpen">|</div>

        <div class="rubr" (mouseenter)="menuOpen ? '': ongletsVis = true;" >
            <div (click)="ongletsVis = true;">Banque / Assurance </div>
            <div *ngIf="ongletsVis" class="onglets" (mouseleave)="ongletsVis = false;">
                <div *ngIf="ongletsVis"  (click)="nav.nav('assurance-auto')">Assurance auto</div>
                <div *ngIf="ongletsVis"  (click)="nav.nav('assurance-habitation')">Assurance habitation</div>
                <div *ngIf="ongletsVis"  (click)="nav.nav('assurance-sante')">Assurance santé</div>
                <div *ngIf="ongletsVis"  (click)="nav.nav('assurance-professionnelle')">Assurance Professionnelle</div>
                <div *ngIf="ongletsVis"  (click)="nav.nav('assurance-accidents')">Assurance accidents de la vie</div>
                <div *ngIf="ongletsVis"  (click)="nav.nav('assurance-pret')">Assurance prêt</div>
            </div>
        </div>

        <div *ngIf="!menuOpen">|</div>
        
        <div class="rubr" (click)="this.menuOpen = false; nav.nav('cryptomonnaies');">
                Cryptomonnaies
        </div>


        <div *ngIf="!menuOpen">|</div>

        <div class="rubr" (click)="this.menuOpen = false; nav.nav('contact')"> 
            Contact
        </div>

        <div *ngIf="!menuOpen">|</div>

        <div class="rubr" (click)="this.menuOpen = false; nav.nav('actualites')"> 
            Actualités
        </div>
    </div>
</div>
